'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const designSystemContext = require('@zapier/design-system-context');
const utils_fromEntries = require('../../../utils/fromEntries.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const link = "_link_1vym7_1";
const styles = {
	link: link
};

const DOMAIN_WHITELIST = ["zapier.com", "zapier-staging.com", "localhost"];
const isLinkExternal = (href) => {
  if (!href || href.length === 0) {
    return false;
  }
  const matcher = /(^[?#/]|http)|^[^.]+(\/)/;
  let hrefWithProtocol = href;
  if (!matcher.test(href)) {
    hrefWithProtocol = `https://${href}`;
  }
  const baseUrl = "https://zapier.com";
  let url;
  try {
    url = new URL(hrefWithProtocol, baseUrl);
  } catch (_) {
    return true;
  }
  const [topLevelDomain, secondLevelDomain] = url.host.split(":")[0].split(".").reverse();
  const domain = secondLevelDomain ? `${secondLevelDomain}.${topLevelDomain}` : topLevelDomain;
  return !DOMAIN_WHITELIST.includes(domain);
};
const buildRel = (rel, isExternal, noReferrer) => {
  const externalLinkRel = [];
  if (isExternal) {
    externalLinkRel.push("noopener");
  }
  if (isExternal && noReferrer) {
    externalLinkRel.push("noreferrer");
  }
  const propsRel = rel && rel.split(/\s+/) || [];
  return [.../* @__PURE__ */ new Set([...propsRel, ...externalLinkRel])].join(" ") || void 0;
};
const Link = React.forwardRef(function Link2(props, ref) {
  const { color = "primary", component: Component, noReferrer = true, weight = "inherit", "aria-label": ariaLabel, "aria-current": ariaCurrent } = props;
  const colorMaybeNull = color === "inherit" ? null : color;
  const trimmedHref = props.href ? props.href.trim() : props.href;
  const { LinkComponent: ContextLink } = designSystemContext.useDesignSystem();
  const LinkComponent = Component || ContextLink;
  const dataAttributes = utils_fromEntries.fromEntries(Object.entries(props).filter(([key]) => {
    return key.startsWith("data-");
  }));
  return React__default.default.createElement(LinkComponent, Object.assign({ "aria-current": ariaCurrent, "aria-label": ariaLabel, className: props.className ? props.className : styles.link, "data-color": props.className ? void 0 : colorMaybeNull, "data-weight": props.className ? void 0 : weight, "data-zds": true, href: trimmedHref, id: props.id, name: props.name, onBlur: props.onBlur, onClick: props.onClick, onFocus: props.onFocus, onKeyDown: props.onKeyDown, onMouseDown: props.onMouseDown, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, onMouseUp: props.onMouseUp, ref, rel: buildRel(props.rel, isLinkExternal(props.href), noReferrer), role: props.role, style: props.style, tabIndex: props.tabIndex, target: props.target, referrerPolicy: props.referrerPolicy, title: props.title }, dataAttributes), props.children);
});

exports.Link = Link;
//# sourceMappingURL=Link.cjs.js.map
